<template>
    <div class="filter_category">
        <div :id="id" class="category_title" @click="toggleCategory">
            {{ filter.name }}
        </div>
        <div class="filters">
            <div class="filter_rows_wrapper">
                <div
                    v-for="attribute in filter.attributes"
                    :key="attribute.id"
                    class="filter_row"
                >
                    <label class="label_checkbox">
                        <input
                            type="checkbox"
                            @change="onAttributeClick(attribute.id)"
                        />
                        <span class="label_checkbox_content">
                            {{ attribute.value }}
                        </span>
                    </label>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
    props: {
        filter: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            id: `filters-${this.filter.id}`
        };
    },

    methods: {
        ...mapActions({
            initJQuery: 'scripts/initJQuery'
        }),

        onAttributeClick(attributeId) {
            this.$emit('attribute-clicked', {
                attributeId,
                filterId: this.filter.id
            });
        },

        toggleCategory() {
            this.initJQuery();

            const $ = window.jQuery;

            if (window.innerWidth <= 991) {
                $(`#${this.id}`)
                    .toggleClass('active')
                    .next('.filters')
                    .slideToggle(300);
            }
        }
    }
};
</script>
